import { render, staticRenderFns } from "./work.vue?vue&type=template&id=16e196aa&scoped=true&"
import script from "./work.vue?vue&type=script&lang=js&"
export * from "./work.vue?vue&type=script&lang=js&"
import style0 from "./work.vue?vue&type=style&index=0&id=16e196aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e196aa",
  null
  
)

export default component.exports